import {
  GET_ADMIN_TWILIO_NUMBERS,
  GET_ADMIN_TWILIO_NUMBERS_SUCCESS,
  GET_ADMIN_TWILIO_NUMBERS_ERROR,
  DELETE_ADMIN_TWILIO_NUMBER,
  DELETE_ADMIN_TWILIO_NUMBER_SUCCESS,
  DELETE_ADMIN_TWILIO_NUMBER_ERROR,
  EXPORT_ADMIN_TWILIO_NUMBERS,
  EXPORT_ADMIN_TWILIO_NUMBERS_SUCCESS,
  EXPORT_ADMIN_TWILIO_NUMBERS_ERROR
} from "./actionTypes"
import { buildCampaignAnalysisCacheKey as buildPaginationCacheKey } from "helpers/sf_utils"

const initialState = {
  loading: false,
  admin_twilio_numbers: [],
  error: null,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  active_cache_key: null,
  page_cache: {},
  export_loading: false,
  export_error: null,
}

const AdminTwilioNumbers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_TWILIO_NUMBERS: {
      const page_number = action.paginated ? (action.payload.queryParams.page_number || 1) : 1
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        page_number === 1 &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null

      return {
        ...state,
        error: null,
        active_cache_key: useCache ? cacheKey : null,
        loading: !cachedPage,
        admin_twilio_numbers: cachedPage?.rows || ((page_number === 1) ? [] : state.admin_twilio_numbers),
        last_page_fetched: cachedPage?.page_number ?? state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages ?? state.total_number_of_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }
    }

    case GET_ADMIN_TWILIO_NUMBERS_SUCCESS: {
      const rows = action.payload.data || []
      const additional = action.payload.additional_data || {}
      const useCache = Boolean(action.meta?.useCache)
      const cacheKey = useCache ? buildPaginationCacheKey(action.meta?.queryParams || {}) : null
      const pageNum = parseInt(additional.page_number, 10)
      const totalPages = parseInt(additional.total_number_of_pages, 10)
      const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
      const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
      const pageSnapshot = { rows, page_number: safePage, total_number_of_pages: safeTotal }

      return {
        ...state,
        error: null,
        admin_twilio_numbers: rows,
        loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        active_cache_key: useCache ? cacheKey : state.active_cache_key,
        page_cache: useCache ? {
          ...state.page_cache,
          [cacheKey]: {
            ...(state.page_cache?.[cacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }
    }

    case GET_ADMIN_TWILIO_NUMBERS_ERROR:
      return {
        ...state,
        loading: false,
      }

    case DELETE_ADMIN_TWILIO_NUMBER:
      return {
        ...state,
        loading: true,
      }

    case DELETE_ADMIN_TWILIO_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        // Patch the current-page display immediately; clear cache so other pages refetch fresh
        admin_twilio_numbers: state.admin_twilio_numbers.map((item) =>
          item.id !== action.payload.id ? item : { ...item, ...action.payload }
        ),
        page_cache: {},
      }

    case DELETE_ADMIN_TWILIO_NUMBER_ERROR:
      return {
        ...state,
        loading: false,
      }

    case EXPORT_ADMIN_TWILIO_NUMBERS:
      return {
        ...state,
        export_loading: true,
        export_error: null,
      }

    case EXPORT_ADMIN_TWILIO_NUMBERS_SUCCESS:
      return {
        ...state,
        export_loading: false,
        export_error: null,
      }

    case EXPORT_ADMIN_TWILIO_NUMBERS_ERROR:
      return {
        ...state,
        export_loading: false,
        export_error: action.payload,
      }

    default:
      return state
  }
}

export default AdminTwilioNumbers
